import { render, staticRenderFns } from "./FaceDirectionResultEffectFaceFront.vue?vue&type=template&id=522dcad4&"
import script from "./FaceDirectionResultEffectFaceFront.vue?vue&type=script&lang=ts&"
export * from "./FaceDirectionResultEffectFaceFront.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports